import { HttpLink } from '@apollo/client';
import { envs } from '@config';

export const httpMiddleware = new HttpLink({
  uri: envs.graphqlHttpUrl,
});
